import { Box } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  BottomSheetLoadingContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

interface TimesheetUploadBottomSheetProps {
  modalState: UseModalState;
  onContinue: () => void;
  isUploading: boolean;
  isUploadError: boolean;
  onTryAgain: () => void;
}

export function TimesheetUploadBottomSheet(props: TimesheetUploadBottomSheetProps) {
  const { modalState, onContinue, isUploading, isUploadError, onTryAgain } = props;
  const handleContinue = useCallback(() => {
    modalState.closeModal();
    onContinue();
  }, [modalState, onContinue]);

  if (isUploading) {
    return (
      <BottomSheet canDismiss={false} modalState={modalState}>
        <BottomSheetLoadingContent
          title="Uploading timesheet"
          description="Please wait while we process your timesheet..."
        />
      </BottomSheet>
    );
  }

  if (isUploadError) {
    return (
      <BottomSheet canDismiss={false} modalState={modalState}>
        <BottomSheetIllustrationContent
          illustrationType="error"
          title="Upload failed"
          description="Something went wrong while uploading your timesheet. Please try again."
        />
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              onTryAgain();
            }}
          >
            Try again
          </Button>
        </DialogFooter>
      </BottomSheet>
    );
  }

  return (
    <BottomSheet canDismiss={false} modalState={modalState}>
      <Box sx={{ paddingX: 4 }}>
        <BottomSheetIllustrationContent
          hasFooter
          illustrationType="clock"
          title="Timesheet submitted!"
          description="Our team is reviewing your timesheet. Once verified, your pay and Clipboard Score balance will be adjusted based on the provided clock times."
        />
      </Box>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={handleContinue}>
          Continue
        </Button>
      </DialogFooter>
    </BottomSheet>
  );
}
